const OKLCH_RE = /oklch\((?:[^)(]|\([^)]*\))*\)/g;

const toRgb = (oklch: string): string => {
  const c = document.createElement("canvas");
  c.width = c.height = 1;
  const ctx = c.getContext("2d");
  if (!ctx) return oklch;
  // Sentinel detects silent rejection: canvas keeps previous fillStyle without throwing
  ctx.fillStyle = "rgb(1, 2, 3)";
  ctx.fillStyle = oklch;
  if (ctx.fillStyle === "rgb(1, 2, 3)") return oklch;
  ctx.fillRect(0, 0, 1, 1);
  const [r, g, b, a] = ctx.getImageData(0, 0, 1, 1).data;
  return a < 255 ? `rgba(${r}, ${g}, ${b}, ${(a / 255).toFixed(3)})` : `rgb(${r}, ${g}, ${b})`;
};

export const replaceOklchInClone = (clonedDoc: globalThis.Document): void => {
  // 1. Replace oklch in <style> tags
  clonedDoc.querySelectorAll("style").forEach((styleEl) => {
    if (styleEl.textContent?.includes("oklch")) {
      styleEl.textContent = styleEl.textContent.replace(OKLCH_RE, toRgb);
    }
  });

  // 2. Replace oklch in inline style attributes on all elements
  clonedDoc.querySelectorAll("[style]").forEach((el) => {
    const style = el.getAttribute("style");
    if (style?.includes("oklch")) {
      el.setAttribute("style", style.replace(OKLCH_RE, toRgb));
    }
  });

  // 3. Inline any linked stylesheets that contain oklch so html2canvas
  //    can parse them (it only sees <style> tags in the cloned document)
  try {
    for (const sheet of Array.from(document.styleSheets)) {
      // Only process linked stylesheets (<link> tags); <style> tags are handled in step 1
      if (!sheet.href) continue;

      let cssText: string;
      try {
        cssText = Array.from(sheet.cssRules)
          .map((r) => r.cssText)
          .join("\n");
      } catch {
        // Cross-origin stylesheets throw on cssRules access - skip them
        continue;
      }
      if (!cssText.includes("oklch")) continue;

      const inlinedStyle = clonedDoc.createElement("style");
      inlinedStyle.textContent = cssText.replace(OKLCH_RE, toRgb);
      clonedDoc.head.appendChild(inlinedStyle);

      // Remove the corresponding <link> from the clone so rules don't double-apply.
      // Compare via HTMLLinkElement.href (resolved absolute URL) since sheet.href
      // is absolute but the <link> attribute value may be relative.
      clonedDoc.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
        if ((link as HTMLLinkElement).href === sheet.href) {
          link.remove();
        }
      });
    }
  } catch {
    // Graceful fallback - if stylesheet inlining fails, html2canvas
    // will still attempt to render with whatever it can parse
  }
};
